import { render, staticRenderFns } from "./Concessoes.vue?vue&type=template&id=75f6fd1a"
import script from "./Concessoes.vue?vue&type=script&lang=js"
export * from "./Concessoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports